import * as XLSX from 'xlsx';
import type { PaymentRequest } from './api/payments';

const TYPE_LABEL: Record<string, string> = {
  chi_thuong: 'Thanh toán',
  tam_ung: 'Tạm ứng',
  hoan_ung: 'Hoàn ứng',
  thuong_nong: 'Thưởng nóng',
};

const STATUS_LABEL: Record<string, string> = {
  DRAFT: 'Nháp',
  PENDING_KTT: 'Chờ KTT duyệt',
  PENDING_CEO: 'Chờ CEO ký',
  APPROVED: 'Đã duyệt',
  REJECTED: 'Từ chối',
  DISBURSED: 'Đã chi',
  CANCELLED: 'Đã huỷ',
};

const ADVANCE_LABEL: Record<string, string> = {
  planned: 'Có kế hoạch',
  urgent: 'Đột xuất',
};

/** Định dạng ngày cho Excel: yyyy-MM-dd (Excel tự nhận là date). */
function fmtDate(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
}

export function exportPaymentsToExcel(items: PaymentRequest[], filename?: string): void {
  const rows = items.map((p) => ({
    'Mã đề nghị': p.code,
    'Ngày tạo': fmtDate(p.createdAt),
    'Ngày gửi duyệt': fmtDate(p.submittedAt),
    'Ngày đã chi': fmtDate(p.disbursedAt),
    'Loại': TYPE_LABEL[p.type] || p.type,
    'Loại tạm ứng': p.advanceType ? ADVANCE_LABEL[p.advanceType] || p.advanceType : '',
    'Khẩn': p.urgency ? 'Khẩn' : '',
    'Số tiền': p.amount,
    'Người đề nghị': p.requesterName || p.requesterId,
    'Phòng ban': p.department || '',
    'Nhà cung cấp / Người nhận': p.supplier || '',
    'Số TK ngân hàng': p.bankAccount || '',
    'Lý do': p.reason,
    'Trạng thái': STATUS_LABEL[p.status] || p.status,
    'Số chứng từ đính kèm': p.attachments?.length || 0,
    'Số NV nhận thưởng': p.recipients?.length || 0,
  }));

  const ws = XLSX.utils.json_to_sheet(rows);

  // Đặt width tự động (rough): mỗi cột theo chiều dài header + max value
  const cols = Object.keys(rows[0] ?? { 'Mã đề nghị': '' }).map((key) => {
    const maxLen = Math.max(
      key.length,
      ...rows.map((r) => String((r as Record<string, unknown>)[key] ?? '').length),
    );
    return { wch: Math.min(60, Math.max(10, maxLen + 2)) };
  });
  ws['!cols'] = cols;

  // Format cột "Số tiền" thành number với thousand separator
  if (rows.length > 0) {
    const amountColIdx = Object.keys(rows[0]).indexOf('Số tiền');
    if (amountColIdx >= 0) {
      const colLetter = XLSX.utils.encode_col(amountColIdx);
      for (let i = 2; i <= rows.length + 1; i++) {
        const cell = ws[`${colLetter}${i}`];
        if (cell) cell.z = '#,##0';
      }
    }
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Đề nghị chi');

  const name = filename || `de-nghi-chi-${new Date().toISOString().slice(0, 10)}.xlsx`;
  XLSX.writeFile(wb, name);
}
